import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSalesInvoiceListMutation } from '../../../../store/api/salesinvoice';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
import { usePostSalesInvoicedCountApiMutation, usePostSalesInvoiceListApiMutation } from "../../../../store/api/salesinvoiceAuricApi";
import { useGetSelectedCompanyQuery } from "../../../../store/api/companyapi";

const Maincontent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling, pageSize } = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [salesInvoice, setSalesInvoice] = useState({ sales_invoices: [], total_no_of_records: 0 });
    const [getSalesInvoiceList] = useGetSalesInvoiceListMutation();
    const [salesInvoiceList] = usePostSalesInvoiceListApiMutation();
    const [salesInvoiceCountApi] = usePostSalesInvoicedCountApiMutation();
    // const { data: salesInvoiceCount , isLoading, refetch: refetchSalesInvoiceCount } = useGetSalesInvoiceCountQuery();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [totalCount, settotalCount] = useState(0);
    const [deleteDoc] = useDeleteDocMutation();
    const getcompany = useGetSelectedCompanyQuery();
    const selectedComapny = getcompany?.data?.message?.data?.company.split(" - ")[0];


    const filtersConfig = [
        // { name: 'siNo', label: 'S. No.', width: '6%', type: 'number' },
        { name: 'name', label: 'ID', width: '15%', type: 'text' },
        { name: 'title', label: 'Title', width: '15%', type: 'text' },
        { name: 'customer', label: 'Customer', width: '15%', type: 'text' },
        // { name: 'company', label: 'Company', type: 'text', width: '12%' },
        { name: 'status',
            label: 'Status',
            width: '13.7%',
            type: 'select',
            options: [
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Return', label: 'Return' },
                { value: 'Cancelled', label: 'Cancelled' },
                { value: 'Credit Note Issued', label: 'Credit Note Issued' },
                { value: 'Submitted', label: 'Submitted' },
                { value: 'Paid', label: 'Paid' },
                { value: 'Partly Paid', label: 'Partly Paid' },
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Unpaid and Discounted', label: 'Unpaid and Discounted' },
                { value: 'Partly Paid and Discounted', label: 'Partly Paid and Discounted' },
                { value: 'Overdue and Discounted', label: 'Overdue and Discounted' },
                { value: 'Overdue', label: 'Overdue' },
                { value: 'Internal Transfer', label: 'Internal Transfer' },
            ]
        },
        { name: 'creation', label: 'Created By', type: 'date', width: '12%' },
    ];


    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '6%',
            cellRenderer: (row)=> row.siNo,
            sortable: false,
            visible: true
        },
        // {
        //     header: "Title",
        //     name: "Title",
        //     accessor: "title",
        //     width: '15%',
        //     sortable: true,
        //     visible: true
        // },
        {
            header: "Id",
            name: "Id",
            accessor: "name",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Main Cost Center",
            name: "",
            accessor: "",
            width: '15%',
            sortable: true,
            visible: true
        },
            {
            header: "Company",
            name: "",
            accessor: "",
            width: '12%',
            sortable: true,
            visible: true,
        },
        {
            header: "Date & Time",
            name: "creation",
            accessor: "creation",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.date) - new Date(b.date)
            // sortFn: (a, b) => parseFloat(a.gst_amount) - parseFloat(b.gst_amount)
        },
        // {
        //     header: "Status",
        //     name: "Status",
        //     accessor: "status",
        //     width: '15%',
        //     sortable: true,
        //     visible: false
        // },

        // {
        //     header: "Status",
        //     name: "Status",
        //     accessor: "status",
        //     width: '13%',
        //     sortable: true,
        //     visible: true,
        //     cellRenderer: (row) => {
        //         const status = row.status;
        //         let color;
        //         switch (status) {
        //             case 'Unpaid': color = '#F97316'; break;
        //             case 'Draft': color = '#6366F1'; break;
        //             case 'Overdue': color = '#F97316'; break;
        //             case 'To Deliver and Bill': color = '#6B21A8'; break;
        //             case 'Pick List Created': color = '#0E7490'; break;
        //             case 'To Bill': color = '#D97706'; break;
        //             case 'Completely Picked': color = '#65A30D'; break;
        //             case 'Cancelled': color = '#EF4444'; break;
        //             case 'Closed': color = '#E11D48'; break;
        //             default: color = '#000000';
        //         }
        //         return (
        //             <span
        //                 style={{
        //                     backgroundColor: `${color}1A`,
        //                     color,
        //                     padding: '4px 10px',
        //                     borderRadius: '9999px',
        //                     fontSize: '12px',
        //                     fontWeight: 500,
        //                     display: 'inline-block',
        //                     textTransform: 'capitalize',
        //                 }}
        //             >
        //                 {status}
        //             </span>
        //         );
        //     }
        // },
    
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            visible: true,
            accessor: "action",
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.id}
                    onView={() => handleView(row.id)}
                    onEdit={() => handleEdit(row.id)}
                    onDelete={() => handleDelete(row.id)}
                />
            )
        }
    ]);


    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);
    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);

    const handleView = (id) => navigate(`/master/quality-goal/view-quality-goal`, { state: { sales_invoice_id: id } });
    const handleEdit = (id) => navigate(`/master/quality-goal/edit-quality-goal`, { state: { sales_invoice_id: id } });
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Quality Goal?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Quality Goal", name: delSelectedId }).unwrap()
            setDelmessage(`Quality Goal ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Quality Goal!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
           className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "btnsecond border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "btnthird border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
			to: "/master/quality-goal/create-quality-goal",
			iconName: "FiPlus",
			style: { gap: "2px", height: "28px" },
			children: "Create Quality Goal",
        }
    ];

  const getData = async () => {
  setLoading(true);
  try {



    const filteredSearchInput = Object.entries(filters).reduce(
      (acc, [key, value]) => {
        if (value !== "" && value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      },
      {}
    );

    const filtersArray = [];
    //   filtersArray.push(["Quality Goal", "company", "=", selectedComapny]);
    if (filteredSearchInput.name) {
      filtersArray.push(["Quality Goal", "name", "like", `%${filteredSearchInput.name}%`]);
    }
    if (filteredSearchInput.title) {
      filtersArray.push(["Quality Goal", "title", "like", `%${filteredSearchInput.title}%`]);
    }
    if (filteredSearchInput.customer) {
      filtersArray.push(["Quality Goal", "customer", "like", `%${filteredSearchInput.customer}%`]);
    }
    if (filteredSearchInput.status) {
      filtersArray.push(["Quality Goal", "status", "=", filteredSearchInput.status]);
    }
    if (filteredSearchInput.creation) {
      filtersArray.push(["Quality Goal", "posting_date", "=", filteredSearchInput.creation]);
    }
    console.log("check check this check is ",filteredSearchInput);

     const formData = new FormData();

        formData.append("doctype", "Quality Goal");
        formData.append(
          "fields",
          JSON.stringify(["`tabQuality Goal`.`name`","`tabQuality Goal`.`owner`","`tabQuality Goal`.`creation`","`tabQuality Goal`.`modified`","`tabQuality Goal`.`modified_by`","`tabQuality Goal`.`_user_tags`","`tabQuality Goal`.`_comments`","`tabQuality Goal`.`_assign`","`tabQuality Goal`.`_liked_by`","`tabQuality Goal`.`docstatus`","`tabQuality Goal`.`idx`","`tabQuality Goal`.`frequency`","`tabQuality Goal`.`procedure`"])
        );
        formData.append("page_length", pageSize);
        formData.append("start", pageSize * (currentPage - 1));

        if (filtersArray && filtersArray.length > 0) {
          formData.append("filters", JSON.stringify(filtersArray));
        }


    const response = await salesInvoiceList(formData).unwrap();

    const raw = response?.message?.values || [];
    const mapped = raw.map((row, index) => ({
      name: row[0],
      creation: new Date(row[3]).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }),
      title: row[2],
      customer: row[3],
      company: row[4],
      status: row[5],
      siNo: index + 1 + pageSize * (currentPage - 1),
    }));

    setSalesInvoice({
      sales_invoices: mapped,
      total_no_of_records: mapped.length,
    });
  } catch (error) {
    console.error("Error fetching new Quality Goals:", error);
  } finally {
    setLoading(false);
  }
};


    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
            const getcount = async() =>{
                try {
                       const filteredSearchInput = Object.entries(filters).reduce(
                            (acc, [key, value]) => {
                                if (value !== "" && value !== undefined && value !== null) {
                                acc[key] = value;
                                }
                                return acc;
                            },
                            {}
                        );
                         const filtersArray = [];
                            // filtersArray.push(["Quality Goal","company","=",selectedComapny]);
                            if (filteredSearchInput.customer) {
                            filtersArray.push(["Quality Goal", "customer", "=", filteredSearchInput.customer]);
                            }
                            if (filteredSearchInput.status) {
                            filtersArray.push(["Quality Goal", "status", "=", filteredSearchInput.status]);
                            }

                    const formData = new FormData();
                    formData.append("doctype", "Quality Goal");

                    formData.append("filters", JSON.stringify(filtersArray));
                    

                    const responsecount = await salesInvoiceCountApi(formData);
                    settotalCount(responsecount.data.message)
                } catch (error) {
                    console.log("check error msg",error);
                }
            }
            getcount()
            getData();
    }, [selectedComapny, currentPage, filters, pageSize, screenHeight, screenScaling]);





    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Quality Goal" },
                    { label: "Quality Goal List", style: { color: '#4b002b' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Quality Goal"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "id","customer","status","date", "action"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={salesInvoice.sales_invoices}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={totalCount}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Quality Goal"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Maincontent;